export default __webpack_public_path__ + "static/media/caretaker-3.10c5becd.svg";